import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeaturedInSection } from './components/FeaturedInSection';
import { BenefitsSections } from './components/BenefitsSections';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProductDetails } from './components/ProductDetails';
import { ComparisonSection } from './components/ComparisonSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { ProblemSolutionSection } from './components/ProblemSolutionSection';
import { ProductFeatures } from './components/ProductFeatures';
import { CustomerReviews } from './components/CustomerReviews';
import { PerfectForSection } from './components/PerfectForSection';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-full bg-white font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main className="w-full" data-id="element-3">
        <HeroSection data-id="element-4" />
        <FeaturedInSection data-id="element-5" />
        <ProblemSolutionSection data-id="element-6" />
        <BenefitsSections data-id="element-7" />
        <ProductFeatures data-id="element-8" />
        <PerfectForSection data-id="element-9" />
        <CustomerReviews data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <ProductDetails data-id="element-12" />
        <ComparisonSection data-id="element-13" />
        <FAQSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}